<template>
	<div v-wechat-title="$route.meta.title" class="wrap">
		<div v-if="showRotateTips" class="rotatePage horizontal-screen-mask">
			<horizontal-screen :isInApp="isInApp" :querys="querys" :showRotateTips="showRotateTips" :hidePageOne="hidePageOne" :getQuery="getQuery"></horizontal-screen>
		</div>
		<div v-else class="year-review" ref="">
			<div class="swiper-container swiper-box">
				<div class="swiper-wrapper swiper-report" id="wholeReport">
					<div class="swiper-slide" v-if="showReport">
						<year-report :goToStatic="goToStatic" :changeInitialSlide="changeInitialSlide" :getQuery="getQuery" :hidePageOne="hidePageOne" ref="swiperReport"></year-report>
					</div>
					<div class="swiper-slide swiper-static">
						<year-static :isInApp="isInApp" ref="static" :showRotateTips="showRotateTips" :swiper="swiper"></year-static>
					</div>
				</div>
			</div>
			<explore-tp :isInApp="isInApp" :querys="querys"></explore-tp>
		</div>
	</div>
</template>
<script>
import { getMobelType } from '@/utils/getMobelType.js'
import mixpanel from '@/utils/mixpanel.js'
import yearReport from './yearReport.vue'
import yearStatic from './yearStatic.vue'
import exploreTp from './components/exploreTp.vue'
import Swiper from 'swiper'
import 'swiper/css/swiper.css'
import '@/utils/flexible.js'
// import Vconsole from 'vconsole'
import horizontalScreen from './horizontalScreen.vue'
export default {
  components: {
    // yearReviewMap,
    exploreTp,
    // reviewShare,
    yearReport,
    yearStatic,
    horizontalScreen
    // swiper,
    // swiperSlide
  },
  data() {
    return {
      isExplore: getMobelType().truckerpath,
      showReport: true,
      showStatic: true,
      curReport: 0,
      initialSlide: 0,
      isInApp: true,
      cookie: '',
      swiper: null,
      showRotateTips: false,
      querys: null
    }
  },
  created() {
    mixpanel.initMixpanel(process.env['VUE_APP_MIX_KEY']) // 测试环境
    // console.log(process.env['VUE_APP_MIX_KEY'])
    // new Vconsole()
    window.addEventListener('DOMContentLoaded', () => this.orientationChange(), true)
    window.addEventListener('resize', () => this.orientationChange(), true)
    window.addEventListener('orientationchange', () => this.orientationChange(), true)
  },
  mounted() {
    this.initData()
    this.cookie = document.cookie
    this.isInApp =
			this.cookie.indexOf('driver-token') > -1 || this.cookie.indexOf('distinct-id') > -1 || this.cookie.indexOf('installation-id') > -1 || this.cookie.indexOf('device-id') > -1 || this.cookie.indexOf('internal-user-id') > -1
    if (this.isInApp) {
      mixpanel.track('User Growth Campaign', { Outcome: 'Screen view', 'Campaign name': '2019 Year in Review', 'View Type': 'User view' })
    } else {
      mixpanel.track('User Growth Campaign', { Outcome: 'Screen view', 'Campaign name': '2019 Year in Review', 'View Type': 'Sharing view' })
    }
    this.orientationChange()
    this.$refs.swiperReport.initView()
  },
  methods: {
    orientationChange() {
      switch (window.orientation) {
      case 0:
        this.showRotateTips = false
        this.initData()
        break
      case 90:
        this.showRotateTips = true
        break
      case -90:
        this.showRotateTips = true
        break
      case 180:
        this.showRotateTips = false
        this.initData()
        break
      }
    },
    initData() {
      // 初始化swiper
      this.$nextTick(() => {
        // console.log('nextTick')
        this.swiperInit()
      })
    },
    swiperInit() {
      const that = this
      this.swiper = new Swiper('.swiper-container', {
        direction: 'vertical', //纵向
        passiveListeners: false,
        allowTouchMove: true,

        // observer:true,
        // observeParents:true,
        on: {
          slideChangeTransitionEnd: function() {
            that.curReport = this.activeIndex
            if (this.activeIndex === 1 || !this.showReport) {
              that.swiper.params.noSwiping = true
              that.swiper.params.noSwipingClass = 'swiper-static'
              setTimeout(() => {
                that.$refs.static.ani()
              })
            } else {
              that.swiper.params.noSwiping = false
              // this.swiper.params.noSwipingClass = 'no-swiper'
            }
          }
        }
      })
      var startScroll, touchStart, touchCurrent
      this.swiper.slides.on(
        'touchstart',
        function(e) {
          startScroll = this.scrollTop //当前获取滚动条顶部的偏移
          touchStart = e.targetTouches[0] && e.targetTouches[0].pageY //手指触碰位置距离盒子顶部距离
        },
        true
      )
      this.swiper.slides.on(
        'touchmove',
        function(e) {
          touchCurrent = e.targetTouches[0] && e.targetTouches[0].pageY
          var touchesDiff = touchCurrent - touchStart
          var slide = this
          var onlyScrolling =
						slide.scrollHeight > slide.offsetHeight &&
						((touchesDiff < 0 && startScroll === 0) || (touchesDiff > 0 && startScroll === slide.scrollHeight - slide.offsetHeight) || (startScroll > 0 && startScroll < slide.scrollHeight - slide.offsetHeight))
          if (onlyScrolling) {
            e.stopPropagation()
          }
        },
        true
      )
      // return
    },
    goToStatic() {
      this.swiper.slideNext()
      if (this.isInApp) {
        mixpanel.track('User Growth Campaign', { Outcome: 'Second page view', 'Campaign name': '2019 Year in Review', 'View Type': 'User view' })
      } else {
        mixpanel.track('User Growth Campaign', { Outcome: 'Second page view', 'Campaign name': '2019 Year in Review', 'View Type': 'Sharing view' })
      }
    },
    changeInitialSlide(i) {
      // console.log(i, ',...i')
      this.swiper.params.initialSlide = i
      this.swiper.update()
    },
    getQuery(query) {
      this.querys = query
      // console.log(query, '....query')
    },
    hidePageOne(res) {
      this.showReport = res.flag
      if (!this.showReport) {
        setTimeout(() => {
          this.$refs.static.ani()
        })
        if (this.isInApp) {
          mixpanel.track('User Growth Campaign', { Outcome: 'Second page view', 'Campaign name': '2019 Year in Review', 'View Type': 'User view' })
        } else {
          mixpanel.track('User Growth Campaign', { Outcome: 'Second page view', 'Campaign name': '2019 Year in Review', 'View Type': 'Sharing view' })
        }
      }
      if (res.reason) {
        // console.log(res.reason, '.... 只展示第二页的原因')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/scss/rem.scss';
.year-review {
	max-width: rem(375px);
	height: 100%;
	overflow: auto;
	margin: 0 auto;
	position: relative;
	background-color: #f6fbfe;
	.swiper-box {
		width: 100%;
		height: 100%;
		.swiper-static {
			//  height:auto;
			overflow-y: auto;
		}
	}
}
// .rotatePage{
//   position: fixed;
//   top:0;
//   left: 0;
//   right: 0;
//   bottom:0;
//   margin:auto;
//   background-color: #000;
//   font-size: rem(30px);
//   color:#fff;
//   z-index: 30;
// }
// .rotatePage p{
//   position: absolute;
//   top:0;
//   left: 0;
//   right: 0;
//   bottom: 0;
//   width: 100%;
//   height: rem(30px);
//   margin: auto;
//   text-align: center;
// }
.wrap {
	width: 100%;
	height: 100%;
}
.horizontal-screen-mask {
	width: 100%;
	height: auto;
	overflow-x: hidden;
}
</style>
